import Vue from 'vue'
import Notify from 'vue2-notify'

// Use Notify
Vue.use(Notify, {position: 'top-right'})
